module.exports = __webpack_public_path__ + "static/media/random-institute-JP9BQVlcED8-unsplash.5b7ecfc0.jpg";